import request from '@/apis/request'
const resource = 'game-pricing' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 
}